// This is the notifications when sending invites. Needs to be fixed when rest service is ready
define(function (require) {
  const Marionette = require('backbone.marionette');
  const ViewManager = require('civicsUtils/view_manager');
  const IpsModel = require('civicsBase/ipsModel');
  const invitation_model = require('civicsModels/portal/invitation_model');
  const constants = require('civicsUtils/constants');
  const utils = require('civicsUtils/general_utilities');
	const ConfirmationModal = require('civicsViews/core/confirmation/v_itv_confirmation');
	const invitation_auth_accept_model = require('civicsModels/portal/authorized_user_accept_invitation_model');

  const tpl = require('civicsViews/InviteAuthorizedUsers/templates/t_itv_invite_notifications.hbs');
  return Marionette.ItemView.extend({
    className: 'notification-view',
    tagName: 'div',
    template: tpl,
    events: {
      'click .login-return-link': 'loginRedirectPage',
      'click .create-profile-link': 'registerRedirectPage',
      'click .accept-invite-link': 'acceptAuthInvite',
      'click @ui.btnClose': 'closeClicked'
    },
    childEvents: {
      'check-auth:invite': 'hasInviteRecord',
      'accept:invite': 'acceptAuthInvite',
    },
    ui:{
      linkAccept: '.accept-invite-link',
      inviteNotification: '.invite-notification',
      notifications: '.rhythm-notifications',
      btnClose: '.close-button'
    },

    initialize: function(options) {
      this.config = options.config;
      this.model = options.model;
      this.notificationRegion = options.notificationRegion;
      this.config.id = this.config.inviteKey;
      this.modalRegion = options.modalRegion;
      this.isLoggedIn = App.user.isLoggedIn;
      this.userName = App.user.userName;
    },
    onShow: function() {

    },
    onRender: function() {
      this.$el.rhythmCivicsTooltipInit();
      this.$el.rhythmThemeInit();
      this.$el.rhythmThemeInitCivics();
    },
    hasInviteRecord: function () {
			var inviteAuthStored = App.sessionStorage.get('CIVICS', 'AUTHORIZEDUSER_INVITE');
      return inviteAuthStored != null;
		},
    acceptAuthInvite: function () {
			var modelToAccept = new invitation_auth_accept_model();
			var decode = decodeURIComponent(this.config.inviteCode);
			modelToAccept.invitationToken = decode;
			//modelToAccept.id = this.config.id;
			// modelToAccept.acceptedBy = this.config.registerId;
			var payload = { 'id': this.config.id, 'invitationToken': decode};
			var self = this;
			modelToAccept.save(payload, {
				type: 'PUT',
				success: function (model, response, options) {
					App.sessionStorage.remove('CIVICS', 'AUTHORIZEDUSER_INVITE');
					App.sessionStorage.set('CIVICS', 'AUTHORIZEDUSER_WELCOME_INVITE', true);
          ViewManager.clearUserSpecificSessionStorage(['USER_SESSION'])
          self.dashboardRedirectPage();
				},
				error: function (model, response, options) {
					ViewManager.openAlert(i18n.t('CIVICS.INVITE.ERROR_ACCEPTING_INVITE'));
				},
			});
		},
    dashboardRedirectPage: function (){
      window.location.href = this.config.dashboardRedirectPage; // reload if in dashboard
    },
    registerRedirectPage: function (){
      if (this.config.ssoURL) {
        window.location.assign(this.config.ssoURL);
        return false;
      }
      else {
        window.location.href = this.config.registerUserPage;
      }


    },
    loginRedirectPage: function (){
      if (this.config.ssoURL) {
        window.location.assign(this.config.ssoURL);
        return false;
      }
      else {
      let redirectUrl = this.config.loginRedirectPage;
      redirectUrl += "#invite";
      window.location.href = redirectUrl;
      }
    },
    closeClicked:function(){
      if(this.notificationRegion) {
        this.destroy();
      }
    },
    templateHelpers: function() {
      var self = this;
      
      return {
        userName: this.userName,
        isUserLoggedIn: this.isLoggedIn,
        textExpiredOn: function (){
          if (self.model.get('inviteExpireDate') && self.model.get('inviteExpireDate').includes(constants.DATE_TIME_MIN_VAL)){
            return "";
          } else {
            return i18n.t('CIVICS.INVITE.PUBLIC_VIEW_MESSAGE_EXPIRE_ON')+ Handlebars.helpers["global:formatDate"](self.model.get('inviteExpireDate'));
          }
        }
      };
    }
	});
});
